import TabSelector from '@/global/TabSelector/TabSelector';
import { ResultsTab } from '../types';

type EnrichmentResultsTabsProps = {
  activeTab: ResultsTab;
  onChange: (tab: ResultsTab) => void;
  showFisher: boolean;
  showGsea: boolean;
  showComparison: boolean;
};

const EnrichmentResultsTabs = ({
  activeTab,
  onChange,
  showFisher,
  showGsea,
  showComparison,
}: EnrichmentResultsTabsProps) => {
  const options = [
    { label: 'ORA', value: 'fisher', disabled: !showFisher },
    { label: 'DSEA', value: 'gsea', disabled: !showGsea },
    { label: 'Comparison', value: 'comparison', disabled: !showComparison },
  ];

  if (options.filter(option => !option.disabled).length <= 1) return null;

  return (
    <div className="mt-8" data-demo-tour="enrichment-results-tabs">
      <TabSelector
        options={options}
        value={activeTab}
        onChange={value => onChange(value as ResultsTab)}
        variant="primary"
        size="sm"
      />
    </div>
  );
};

export default EnrichmentResultsTabs;
